import React from 'react';
import { useIntl } from 'react-intl';
import { useBookingContext } from '../../../../hooks/use-booking-context';

interface CostChargeRowProps {
  textId: string;
  amount: number;
}

export const CostChargeRow: React.FC<CostChargeRowProps> = ({ textId, amount }) => {
  const intl = useIntl();
  const { numberFormatter } = useBookingContext();
  const text = textId.length > 0 ? intl.formatMessage({ id: textId }).toUpperCase() : '';

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>{text}</span>
      <span>{numberFormatter.format(amount < 0 ? 0 : amount)}</span>
    </div>
  );
};

export default CostChargeRow;
